// extracted by mini-css-extract-plugin
export default {"page":"News_page__ZtP0d","header":"News_header__BIyeX","list":"News_list__Qok-q","card":"News_card__bR2p5","pagination":"News_pagination__ZyBwD"};